// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
  width: 100% !important;
  max-width: 100% !important;
}

ion-slide {
  border-radius: 10px !important;
}

.airport-name {
  font-size: 12px;
  color: #727272;
  padding-top: 0px;
  max-width: 120px;
}

.line-top {
  z-index: -1;
  background: transparent;
  border: none;
  border-top: dashed 2px #dedede;
  border-radius: 50%;
  height: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.left-plane {
  float: left;
  transform: rotate(-28deg);
  color: #dedede;
}

.right-plane {
  float: right;
  transform: rotate(23deg);
  color: #dedede;
}

.plane {
  margin-top: -39px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.distance {
  font-size: 12px;
  padding-bottom: 5px;
  margin-top: -21px;
  color: #9e9c9c;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.pb-15 {
  padding-bottom: 15px;
}

.pt-20 {
  padding-top: 20px;
}

.flying-time {
  font-size: 12px;
  margin-top: 7px;
  color: #9e9c9c;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.plane-col {
  width: 100%;
}

.schedule-border {
  border-top: 0.5px solid rgb(228, 223, 223);
  padding-top: 10px;
  padding-bottom: 5px;
}

ion-item-sliding {
  background-color: #fff;
  box-shadow: 1px 1px 2px 1px #c7c7c7;
  border-radius: 5px;
  width: calc(100% - 20px);
  margin: auto;
  padding: 6px;
}

.bold {
  font-weight: bold;
}

.time {
  font-size: 11px;
  color: #9e9c9c;
  margin-left: 5px;
  margin-right: 5px;
}

.select-vendor {
  padding: 20px 10px 20px 10px !important;
}

ion-slide {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  height: 138px !important;
  margin-top: 6px !important;
}

.legStatus {
  text-align: center;
  font-size: 13px;
  margin-top: -14px;
}

.scheduleTripStatus {
  margin-top: -15px;
  text-align: center;
  font-size: 12px;
}

ion-item-sliding {
  padding: 0;
  margin-bottom: 15px;
}

ion-item {
  padding-left: 0px !important;
}
ion-item .item-inner {
  padding-right: 0px !important;
}

.legDetails {
  margin-top: 15px;
  margin-bottom: 5px;
}

.legDetailsHeader {
  padding: 5px;
  background: #f6f6ff;
  font-size: 15px;
  height: 40px;
  padding-top: 9px;
}

.legLeftContent {
  margin: auto;
  color: #ffffff;
}
.legLeftContent span {
  color: #727272;
  white-space: nowrap;
}

.legRightContent span {
  color: #727272;
}

.download-border {
  border-top: 0.5px solid rgb(228, 223, 223);
  margin-top: 10px;
}

.download-button {
  font-size: 1.1rem !important;
}

.disabled-list {
  pointer-events: none;
  opacity: 0.4;
}

ion-col,
div,
ion-item,
ion-row {
  --inner-padding-end: none !important;
}

.progress1 {
  width: 100%;
  height: 8px;
  display: block;
  /* Important Thing */
  -webkit-appearance: none;
  border: none;
  opacity: 0.9;
}

.progress1::-webkit-progress-bar {
  border-radius: 50px;
}

/* Now the value part */
.progress1::-webkit-progress-value {
  background: #424242;
  border-radius: 50px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}

.progress1[value]::-webkit-progress-bar {
  background: linear-gradient(to right, #2e7d32, #2e7d32 40%, #ff8f00 50%, #ff8f00, #c62828);
  border-radius: 50px;
  background-size: 100%;
  --webkit-animation: move 5s linear 0 infinite;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/trip-information/trip-downloads/trip-downloads.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,0BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,wBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,0CAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,mCAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,0HAAA;EAEA,wBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,UAAA;EACA,mBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;AAEE;EACE,6BAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,cAAA;AADF;AAGE;EACE,cAAA;EACA,mBAAA;AADJ;;AAME;EACE,cAAA;AAHJ;;AAOA;EACE,0CAAA;EACA,gBAAA;AAJF;;AAOA;EACE,4BAAA;AAJF;;AAOA;EACE,oBAAA;EACA,YAAA;AAJF;;AAMA;;;;EAIE,oCAAA;AAHF;;AAMA;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,YAAA;EACA,YAAA;AAHF;;AAKA;EACE,mBAAA;AAFF;;AAIA,uBAAA;AACA;EACE,mBAAA;EACA,mBAAA;EACA,+CAAA;AADF;;AAGA;EACE,0FAAA;EAQA,mBAAA;EACA,qBAAA;EACA,6CAAA;AAPF","sourcesContent":[".full-width {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\nion-slide {\n  border-radius: 10px !important;\n}\n\n.airport-name {\n  font-size: 12px;\n  color: #727272;\n  padding-top: 0px;\n  max-width: 120px;\n}\n\n.line-top {\n  z-index: -1;\n  background: transparent;\n  border: none;\n  border-top: dashed 2px #dedede;\n  border-radius: 50%;\n  height: 40px;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.left-plane {\n  float: left;\n  transform: rotate(-28deg);\n  color: #dedede;\n}\n\n.right-plane {\n  float: right;\n  transform: rotate(23deg);\n  color: #dedede;\n}\n\n.plane {\n  margin-top: -39px;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.distance {\n  font-size: 12px;\n  padding-bottom: 5px;\n  margin-top: -21px;\n  color: #9e9c9c;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.pb-15 {\n  padding-bottom: 15px;\n}\n\n.pt-20 {\n  padding-top: 20px;\n}\n\n.flying-time {\n  font-size: 12px;\n  margin-top: 7px;\n  color: #9e9c9c;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.plane-col {\n  width: 100%;\n}\n\n.schedule-border {\n  border-top: 0.5px solid rgb(228, 223, 223);\n  padding-top: 10px;\n  padding-bottom: 5px;\n}\n\nion-item-sliding {\n  background-color: #fff;\n  box-shadow: 1px 1px 2px 1px #c7c7c7;\n  border-radius: 5px;\n  width: calc(100% - 20px);\n  margin: auto;\n  padding: 6px;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.time {\n  font-size: 11px;\n  color: #9e9c9c;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.select-vendor {\n  padding: 20px 10px 20px 10px !important;\n}\n\nion-slide {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;\n  height: 138px !important;\n  margin-top: 6px !important;\n}\n\n.legStatus {\n  text-align: center;\n  font-size: 13px;\n  margin-top: -14px;\n}\n\n.scheduleTripStatus {\n  margin-top: -15px;\n  text-align: center;\n  font-size: 12px;\n}\n\nion-item-sliding {\n  padding: 0;\n  margin-bottom: 15px;\n}\n\nion-item {\n  padding-left: 0px !important;\n\n  .item-inner {\n    padding-right: 0px !important;\n  }\n}\n\n.legDetails {\n  margin-top: 15px;\n  margin-bottom: 5px;\n}\n\n.legDetailsHeader {\n  padding: 5px;\n  background: #f6f6ff;\n  font-size: 15px;\n  height: 40px;\n  padding-top: 9px;\n}\n\n.legLeftContent {\n  margin: auto;\n  color: #ffffff;\n\n  span {\n    color: #727272;\n    white-space: nowrap;\n  }\n}\n\n.legRightContent {\n  span {\n    color: #727272;\n  }\n}\n\n.download-border {\n  border-top: 0.5px solid rgb(228, 223, 223);\n  margin-top: 10px;\n}\n\n.download-button {\n  font-size: 1.1rem !important;\n}\n\n.disabled-list {\n  pointer-events: none; //This makes it not clickable\n  opacity: 0.4; //This grays it out to look disabled\n}\nion-col,\ndiv,\nion-item,\nion-row {\n  --inner-padding-end: none !important;\n}\n\n.progress1 {\n  width: 100%;\n  height: 8px;\n  display: block;\n  /* Important Thing */\n  -webkit-appearance: none;\n  border: none;\n  opacity: 0.9;\n}\n.progress1::-webkit-progress-bar {\n  border-radius: 50px;\n}\n/* Now the value part */\n.progress1::-webkit-progress-value {\n  background: #424242;\n  border-radius: 50px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;\n}\n.progress1[value]::-webkit-progress-bar {\n  background: linear-gradient(\n    to right,\n    #2e7d32,\n    #2e7d32 40%,\n    #ff8f00 50%,\n    #ff8f00,\n    #c62828\n  );\n  border-radius: 50px;\n  background-size: 100%;\n  --webkit-animation: move 5s linear 0 infinite;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
